import { getUniqueId } from "@jugl-web/utils";
import { resizeImage } from "./resizeImage";
import {
  FILE_EXTENSION,
  FILE_FORMAT,
  FILE_QUALITY,
  MAX_RESOLUTION,
} from "../consts";

export const saveImageFromCanvas = async (canvas: HTMLCanvasElement) => {
  const blob = await new Promise<Blob | null>((resolve) => {
    canvas.toBlob(resolve, FILE_FORMAT, FILE_QUALITY);
  });

  if (!blob) {
    throw new Error();
  }

  const file = new File([blob], `${getUniqueId()}.${FILE_EXTENSION}`, {
    type: FILE_FORMAT,
  });

  if (canvas.width > MAX_RESOLUTION || canvas.height > MAX_RESOLUTION) {
    return resizeImage(file, MAX_RESOLUTION);
  }

  return file;
};
